import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Input, message, Select, Upload } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { SERVER_ADDRESS } from "../../../Config/Config";
import { useNavigate } from "react-router-dom";

const AddAudio = () => {
  const [form] = Form.useForm();
  const [audioSrc, setAudioSrc] = useState(null);
  const [fileList, setFileList] = useState([]);
  const naviagtion = useNavigate();

  const handleAudioChange = ({ fileList }) => {
    const latestFileList = fileList.slice(-1);
    const latestFile = latestFileList[0];

    if (!latestFile || !latestFile.originFileObj) return;

    const file = latestFile.originFileObj;

    if (file.type !== "audio/mpeg") {
      message.warning("Only MP3 files are allowed.");
      setFileList([]);
      setAudioSrc(null);
      form.setFieldsValue({ audio_file: null });
      return;
    }

    const fileURL = URL.createObjectURL(file);
    const audio = new Audio();
    audio.src = fileURL;

    audio.onloadedmetadata = () => {
      if (audio.duration > 30) {
        message.warning("Audio must be 30 seconds or less.");
        setFileList([]);
        setAudioSrc(null);
        form.setFieldsValue({ audio_file: null });
      } else {
        setFileList(latestFileList);
        setAudioSrc(fileURL);
        form.setFieldsValue({ audio_file: latestFile });
      }
    };
  };

  const handlesubmit = async (values) => {
    const file = fileList[0]?.originFileObj;
    if (!file) {
      message.warning("No file to upload");
      return;
    }

    const formData = new FormData();
    formData.append("audio_name", values.audio_name);
    formData.append("audio_type", values.audio_type);
    formData.append("audio_file", file);

    try {
      const res = await axios.post(
        `${SERVER_ADDRESS}/api/upload-audio`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const result = res.data;
      if (result.result === 1) {
        message.success(result.message);
        naviagtion("/view-audio");
      } else {
        message.warning(result.message);
      }
    } catch (error) {
      message.error("Upload failed");
      console.error(error);
    }
  };

  return (
    <div style={{ marginTop: "4rem" }}>
      <div
        className="mt-3 p-4"
        style={{ backgroundColor: "white", borderRadius: "1rem" }}
      >
        <h3 className="py-4">Add Audio</h3>
        <div style={{ width: "60%", marginInline: "auto" }}>
          <Form onFinish={handlesubmit} form={form} layout="vertical">
            <Form.Item
              name="audio_type"
              label="Audio Name"
              rules={[{ required: true, message: "Select audio type" }]}
            >
              <Select
                placeholder="Select audio Type"
                options={[
                  {
                    value: 1,
                    label: "For You",
                  },
                  {
                    value: 2,
                    label: "Trending",
                  },
                  {
                    value: 3,
                    label: "Recommednded",
                  },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="audio_name"
              label="Audio Name"
              rules={[{ required: true, message: "Enter audio name" }]}
            >
              <Input size="large" placeholder="Enter audio name" />
            </Form.Item>

            <Form.Item
              name="audio_file"
              label="Upload Audio"
              rules={[
                { required: true, message: "Please upload an audio file" },
              ]}
              valuePropName="file"
            >
              <Upload
                accept="audio/*"
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleAudioChange}
                maxCount={1}
                onRemove={() => {
                  setAudioSrc(null);
                  form.setFieldsValue({ audio_file: null });
                  setFileList([]);
                }}
              >
                <Button icon={<UploadOutlined />}>Upload One Audio</Button>
              </Upload>
            </Form.Item>

            {audioSrc && (
              <Form.Item label="Preview">
                <audio controls src={audioSrc} style={{ width: "100%" }} />
              </Form.Item>
            )}

            <Form.Item>
              <Button htmlType="submit" type="primary">
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddAudio;
